require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-why-technical-training-remains-relevant-in-the-era-of-a-i.json") })
        }
      }, "path---blog-why-technical-training-remains-relevant-in-the-era-of-a-i");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-why-technical-training-remains-relevant-in-the-era-of-a-i!./.cache/json/blog-why-technical-training-remains-relevant-in-the-era-of-a-i.json
// module id = 1154
// module chunks = 231608221292675